import {
  type InfiniteData,
  type QueryKey,
  type UseInfiniteQueryOptions,
  useInfiniteQuery as useInfiniteQueryReact,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const useInfiniteQuery = <
  TQueryFunctionData,
  TQueryParams = unknown,
  TError extends AxiosError = AxiosError,
  TData = InfiniteData<TQueryFunctionData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseInfiniteQueryOptions<TQueryFunctionData, TError, TData, TQueryKey, TQueryParams>,
) =>
  useInfiniteQueryReact({
    gcTime: 24 * 60 * 60 * 1000, // 1 Day
    staleTime: 5 * 60 * 1000, // 5 Minutes
    ...options,
  });

export { type InfiniteData, type UseInfiniteQueryOptions } from '@tanstack/react-query';
